export default function isProgressive(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.file = file;
    reader.onloadend = function(eventReader) {
      if (/\xff\xc2/.test(eventReader.target.result)) {
        resolve(true);
      } else {
        resolve(false);
      }
    };
    reader.onerror = function(er) {
      reject(er);
    };
    reader.readAsBinaryString(file);
  });
}
